class CollectionFilters extends window.HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.filterToggles = this.querySelectorAll(".filter-group-toggle");
    this.productsContainer = document.querySelector(".products-list");
    this.loadMoreElement = document.querySelector("collection-load-more");
    if (!this.form) return;
    this.initFilterToggles();
    this.form.addEventListener("submit", this.onFormSubmit.bind(this));
    this.form.addEventListener("change", this.onFilterChange.bind(this));
    this.priceInputs = this.form.querySelectorAll('input[type="number"]');
    this.priceInputs.forEach((input) => {
      input.addEventListener(
        "input",
        this.debounce(this.onPriceInputChange.bind(this), 500)
      );
    });
    this.initFilterSearch();
    this.initMenuAccordions();
  }
  initMenuAccordions() {
    this.querySelectorAll(".menu-accordion-toggle").forEach((btn) => {
      btn.addEventListener("click", () => {
        btn.closest(".menu-filter-accordion").classList.toggle("is-open");
      });
    });
  }
  initFilterSearch() {
    this.querySelectorAll("[data-filter-search]").forEach((input) => {
      input.addEventListener("input", () => {
        const query = input.value.toLowerCase().trim();
        const container = input.closest(".filter-group-content").querySelector(".space-y-2");
        if (!container) return;
        container.querySelectorAll(".filter-checkbox-option").forEach((label) => {
          const text = label.textContent.toLowerCase();
          label.style.display = text.includes(query) ? "" : "none";
        });
      });
    });
  }
  initFilterToggles() {
    this.filterToggles.forEach((toggle) => {
      toggle.addEventListener("click", () => {
        const isExpanded = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", !isExpanded);
      });
    });
  }
  onFilterChange(evt) {
    if (evt.target.type === "checkbox" || evt.target.type === "radio" || evt.target.type === "range") {
      this.submitFilters();
    }
  }
  onPriceInputChange() {
    this.submitFilters();
  }
  onFormSubmit(evt) {
    evt.preventDefault();
    this.submitFilters();
  }
  async submitFilters() {
    const formData = new FormData(this.form);
    const params = new URLSearchParams();
    for (const [key, value] of formData.entries()) {
      if (value) {
        params.append(key, value);
      }
    }
    const url = `${window.location.pathname}?${params.toString()}`;
    try {
      await this.updateProducts(url);
      window.history.pushState({ path: url }, "", url);
      window.scrollTo({ top: 0, behavior: "smooth" });
      this.closeMobileDrawer();
    } catch (error) {
      console.error("Error filtering products:", error);
    }
  }
  closeMobileDrawer() {
    const filtersDrawer = document.querySelector(".filters-drawer");
    const filtersBackdrop = document.querySelector(".filters-backdrop");
    if (filtersDrawer && filtersDrawer.classList.contains("active")) {
      filtersDrawer.classList.remove("active");
    }
    if (filtersBackdrop && filtersBackdrop.classList.contains("active")) {
      filtersBackdrop.classList.remove("active");
    }
    document.body.classList.remove("filters-drawer-open");
  }
  async updateProducts(url) {
    const section = this.closest('[id^="shopify-section-"]');
    if (!section) {
      console.error("Could not find section element");
      return;
    }
    const sectionId = section.id.replace("shopify-section-", "");
    const fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set("section_id", sectionId);
    fetchUrl.hash = "";
    try {
      const response = await fetch(fetchUrl.toString(), {
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newProducts = doc.querySelector(".products-list");
      if (newProducts && this.productsContainer) {
        this.productsContainer.innerHTML = newProducts.innerHTML;
      }
      if (this.loadMoreElement) {
        const newLoadMore = doc.querySelector("collection-load-more");
        if (newLoadMore) {
          const totalProducts = newLoadMore.dataset.totalProducts;
          this.loadMoreElement.updateTotalProducts(totalProducts);
        }
        this.loadMoreElement.reset();
      }
      const newFilters = doc.querySelector("collection-filters");
      if (newFilters) {
        const allFilterInstances = document.querySelectorAll("collection-filters");
        allFilterInstances.forEach((filterInstance) => {
          if (filterInstance) {
            filterInstance.innerHTML = newFilters.innerHTML;
            filterInstance.form = filterInstance.querySelector("form");
            filterInstance.filterToggles = filterInstance.querySelectorAll(
              ".filter-group-toggle"
            );
            filterInstance.productsContainer = document.querySelector(".products-list");
            filterInstance.loadMoreElement = document.querySelector(
              "collection-load-more"
            );
            if (!filterInstance.form) return;
            filterInstance.filterToggles.forEach((toggle) => {
              toggle.addEventListener("click", () => {
                const isExpanded = toggle.getAttribute("aria-expanded") === "true";
                toggle.setAttribute("aria-expanded", !isExpanded);
              });
            });
            filterInstance.form.addEventListener(
              "submit",
              filterInstance.onFormSubmit.bind(filterInstance)
            );
            filterInstance.form.addEventListener(
              "change",
              filterInstance.onFilterChange.bind(filterInstance)
            );
            filterInstance.priceInputs = filterInstance.form.querySelectorAll(
              'input[type="number"]'
            );
            filterInstance.priceInputs.forEach((input) => {
              input.addEventListener(
                "input",
                filterInstance.debounce(
                  filterInstance.onPriceInputChange.bind(filterInstance),
                  500
                )
              );
            });
            filterInstance.initFilterSearch();
            filterInstance.initMenuAccordions();
          }
        });
      }
    } catch (error) {
      console.error("Error updating products:", error);
    }
  }
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}
window.customElements.define("collection-filters", CollectionFilters);
export {
  CollectionFilters as default
};
